import { Button, Tooltip } from '@fluentui/react-components';
import { OpenRegular } from '@fluentui/react-icons';
import { TableActionButtons } from './tables';

type TProps = {
  href: string;
  tooltipContent: string;
};
const ViewDialogItemButton = ({ href, tooltipContent }: TProps) => {
  return (
    <TableActionButtons alwaysVisible>
      <Tooltip content={tooltipContent} relationship="label" withArrow positioning="after">
        <Button
          as="a"
          href={href}
          target="_blank"
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="!min-w-0"
          appearance="transparent"
          icon={<OpenRegular fontSize="16px" />}
          aria-label={tooltipContent}
        />
      </Tooltip>
    </TableActionButtons>
  );
};

export { ViewDialogItemButton };
